import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import it from './locales/it.json';
import wo from './locales/wo.json';

export const SUPPORTED_LANGS = ['es', 'en', 'fr', 'pt', 'ro', 'ar', 'zh', 'it', 'wo'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      ro: { translation: ro },
      ar: { translation: ar },
      zh: { translation: zh },
      it: { translation: it },
      wo: { translation: wo },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18n_lang',
    }
  });

export default i18n;
